<div>
  <div class="mat-h3">
    Prüfregeln
  </div>
  <ul>
    <li>
      <div class="mat-h3">
        Kilometer-Berechnung
      </div>
      <ul>
        <li>
          <div class="mat-h4">Distanzbestimmung</div>
          <p>
            Für die Distanzbestimmung stehen folgende Optionen zur Verfügung:
          </p>
          <ul>
            <li><b>Fahrtenbuch:</b> Die vom Fahrer manuell eingetragenen Streckenangaben.</li>
            <li><b>Kalkulierte Strecke:</b> Die automatisch berechnete Strecke basierend auf den eingegebenen
              Parametern.
            </li>
            <li><b>Weiteste Strecke:</b> Der größere Wert aus der manuell eingetragenen und der berechneten Strecke.
            </li>
          </ul>
        </li>
        <li>
          <div class="mat-h4">Maximale Geschwindigkeit</div>
          <p>
            Die höchstmögliche Geschwindigkeit, die bei Autobahnabschnitten für die Zeitberechnung berücksichtigt wird.
          </p>
        </li>
        <li>
          <div class="mat-h4">Zeitdifferenzfaktor</div>
          <p>
            Gewichtung der Zeitdifferenz zwischen der kürzesten und der empfohlenen Strecke.
            Wird der festgelegte Faktor überschritten, wird automatisch der schnellste Weg gewählt.
          </p>
        </li>
        <li>
          <div class="mat-h4">Kürzeste Strecke bis</div>
          <p>
            Distanz, bis zu der stets die kürzeste Strecke für die Berechnung herangezogen wird.
          </p>
        </li>
      </ul>
    </li>
  </ul>
</div>
